import moment from 'moment';
import store from '../store';
import axios from 'axios';
import { paramsSerializer } from './serializers';
import CONFIG from '../config';
import { formatData } from '@/constants/commonContent';

export function getTransactionPromise (promiseResolve, promiseReject, err, res) {
  if (err) {
    console.error('Error!!!');
    store.commit('approveMemberPending', false);
    return promiseReject(err);
  }
  const DELAY = 5000;
  let isOk = false;
  let isNotOk = false;
  let getStatus = setTimeout(function func () {
    window.web3.eth.getTransactionReceipt(res, (err, res) => {
      if (res != null) {
        if (res.status === '0x1' || res.status === '0x01' || res.status === true) isOk = true;
        if (res.status === '0x0' || res.status === '0x00' || res.status === false) isNotOk = true;
        store.commit('approveMemberPending', false);
      }
    });
    if (isOk || isNotOk) {
      store.commit('approveMemberPending', false);
      return isOk ? promiseResolve(res) : promiseReject(err);
    }
    getStatus = setTimeout(func, DELAY);
  }, DELAY);
}

export async function getTransactionsHistory (btcAddress, ethAddress) {
  CONFIG.etherscan!.history.params.address = ethAddress;
  const headers = store.getters.getHeaders;

  const results: any[] = []

  if (btcAddress) {
    try {
      const result = await axios.get(
        `${CONFIG.backendURL}${CONFIG.endPoints.bitcoinHistory.replace('$address', btcAddress)}`,
        headers
      );
      results.push(result);
    } catch (error) {
      console.error(`Bitcoin history error: ${error.message}`);
    }
  }

  if (ethAddress) {
    try {
      const result = await axios.get(`${CONFIG.etherscan!.url}`, {
        params: CONFIG.etherscan!.history.params,
        paramsSerializer
      });
      results.push(result);
    } catch (error) {
      console.error(`Ethereum history error: ${error.message}`);
    }
  }

  return serializeTransactions(results, btcAddress, ethAddress);
}

export function serializeTransactions (results, btcAddr, ethAddr) {
  let transactions: any[] = [];
  results.forEach(response => {
    const data = response['data'];
    if ('result' in data && Array.isArray(data['result'])) {
      const ethTx = data['result'].map(tx => ({
        address: checkEthInOut(ethAddr, tx) ? [tx.from] : [tx.to || tx.contractAddress],
        contract: isContract(tx),
        direction: checkEthInOut(ethAddr, tx) ? 'IN' : 'OUT',
        amount: [`ETH ${formatData.fromWei(tx.value)}`],
        date: +tx.timeStamp,
        class: +tx.isError || !checkEthInOut(ethAddr, tx) ? 'denied' : 'approved',
        tx
      }));
      transactions = [...transactions, ...ethTx];
    } else if ('trx' in data) {
      const btcTx = data.trx
        .map(tx => {
          const { addresses, values } = getBtcAddresses(btcAddr, tx);
          return {
            address: addresses,
            contract: false,
            direction: checkBtcInOut(btcAddr, tx) ? 'IN' : 'OUT',
            amount: values,
            date: tx.time,
            class: !checkBtcInOut(btcAddr, tx) ? 'denied' : 'approved',
            tx
          };
        })
        .reduce(reduceBtcTransactions, []);
      transactions = [...transactions, ...btcTx];
    }
  });
  transactions = transactions.sort((a, b) => (a.date >= b.date ? -1 : 1));
  transactions.map((tx: any, index) => {
    tx.id = index;
    tx.date = moment.unix(tx.date).format(formatData.dateTime);
    return tx;
  });
  return transactions;
}

function checkEthInOut (address, tx) {
  // true - in, false - out
  return tx.to === address;
}

function isContract (tx) {
  return !tx.to && !!tx.contractAddress;
}

function checkBtcInOut (address, tx) {
  // true - in, false - out
  return (
    tx.out.some(out => out.addr === address) &&
    !tx.inputs.some(input => input.prev_out.addr === address)
  );
}

function getBtcAddresses (address, tx) {
  const addresses: any[] = [];
  const values: any[] = [];
  const arr: any[] = checkBtcInOut(address, tx) ? tx.inputs : tx.out;
  arr.forEach(item => {
    if ('prev_out' in item) {
      const out = tx.out.find(out => out.addr === address && out.value);
      addresses.push(item.prev_out.addr);
      values.push(`BTC ${formatData.fromSatoshiToBTC(out.value)}`);
    } else if (address !== item.addr && item.value) {
      addresses.push(item.addr);
      values.push(`BTC ${formatData.fromSatoshiToBTC(item.value)}`);
    }
  });

  return {
    addresses,
    values
  };
}

function reduceBtcTransactions (arr, tx) {
  let array = arr;
  if (tx.address.length >= 1) {
    array = [
      ...arr,
      ...tx.address.map((address, index) => ({
        address: [address],
        contract: tx.contract,
        direction: tx.direction,
        amount: [tx.amount[index]],
        date: tx.date,
        class: tx.class,
        tx: tx.tx
      }))
    ];
  }
  return array;
}
